import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormControl, Tab, Grid, Table } from "@/comn/components";
import { Page, Group, Layout, Button, ExcelUpload } from "@/comn/components";
import {
    useForm,
    useToast,
    useFetch,
    useModal,
    useAuth,
    useStore,
    useGrid,
    usePopup,
    useResource,
    useExcel,
    usePage,
} from "@/comn/hooks";
import {
    COMN_BASE,
    COMN_URLS,
    COMN_APIS,
    SF_APP_DTL_INVC,
} from "@/tz/go/egaz/osci/lpco/comn/services/OsciLpcoComnAppService";
import { SF_APP_DTL_ADD_ITM, SF_APP_RGST_OFCR_ADD_ITM } from "@/tz/go/egaz/osci/lpco/comn/services/OsciLpcoComnAppAddItmService";
import { APP_DTL_ADD_ITM } from "./APP_DTL_ADD_ITM";
import { APP_RGST_OFCR_ADD_ITM } from "./APP_RGST_OFCR_ADD_ITM";

export const APP_DTL_INVC = (props: any) => {
    const { pgeUid, menuId } = usePage();
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!

    const form = {
        appDtlInvc: useForm({
            defaultSchema: SF_APP_DTL_INVC,
        }),

        appDtlAddItm: useForm({
            defaultSchema: SF_APP_DTL_ADD_ITM,
        }),

        appDtlOfcrAddItm: useForm({
            defaultSchema: SF_APP_RGST_OFCR_ADD_ITM,
        }),
    };

    useEffect(() => {
        handler.setInit();
    }, []);

    /*
     * Application Invoice Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        setInit: async () => {
            fetch.getAppInvcInfo.fetch();
        },
    };

    const fetch = {
        // Get Application Invoice Information !== 신청서 송장 정보 조회 ==!.
        getAppInvcInfo: useFetch({
            api: () => COMN_APIS.getAppInvcInfo({ ...props.state }),
            enabled: !!props.appId,
            onSuccess: (data) => {
                form.appDtlInvc.setValues(data.appInvcInfo?.content || []);
            },
            onError: (error) => {},
            showToast: false,
        }),
    };

    return (
        <>
            <Group>
                <Group.Body>
                    <Layout direction="col">
                        <Layout>
                            <Layout.Left>
                                <Group.Title title={"T_INVC"} titleSize={1}></Group.Title>
                            </Layout.Left>
                        </Layout>

                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.appDtlInvc.schema.dlvrTermsNm} controlSize={10} />
                            </Group.Row>

                            <Group.Row>
                                <Group.Control {...form.appDtlInvc.schema.invcCurrNm} />
                                <Group.Control {...form.appDtlInvc.schema.invcExrt} align="right" />
                            </Group.Row>

                            <Group.Row>
                                <Group.Label label="L_FOB" />
                                <Group.Field>
                                    <Layout>
                                        <Layout.Left size={2}>
                                            <FormControl {...form.appDtlInvc.schema.invcCurrCd}></FormControl>
                                        </Layout.Left>
                                        <Layout.Right>
                                            <FormControl {...form.appDtlInvc.schema.fobVal}></FormControl>
                                        </Layout.Right>
                                    </Layout>
                                </Group.Field>

                                <Group.Control {...form.appDtlInvc.schema.fobTzsVal} align="right" />
                            </Group.Row>

                            <Group.Row>
                                <Group.Label label="L_FRGH" />
                                <Group.Field>
                                    <Layout>
                                        <Layout.Left size={2}>
                                            <FormControl {...form.appDtlInvc.schema.invcCurrCd}></FormControl>
                                        </Layout.Left>
                                        <Layout.Right>
                                            <FormControl {...form.appDtlInvc.schema.frghVal}></FormControl>
                                        </Layout.Right>
                                    </Layout>
                                </Group.Field>

                                <Group.Control {...form.appDtlInvc.schema.frghTzsVal} align="right" />
                            </Group.Row>

                            <Group.Row>
                                <Group.Label label="L_INSR" />
                                <Group.Field>
                                    <Layout>
                                        <Layout.Left size={2}>
                                            <FormControl {...form.appDtlInvc.schema.invcCurrCd}></FormControl>
                                        </Layout.Left>
                                        <Layout.Right>
                                            <FormControl {...form.appDtlInvc.schema.insrVal}></FormControl>
                                        </Layout.Right>
                                    </Layout>
                                </Group.Field>

                                <Group.Control {...form.appDtlInvc.schema.insrTzsVal} align="right" />
                            </Group.Row>

                            <Group.Row>
                                <Group.Label label="L_OTHR_COST" />
                                <Group.Field>
                                    <Layout>
                                        <Layout.Left size={2}>
                                            <FormControl {...form.appDtlInvc.schema.invcCurrCd}></FormControl>
                                        </Layout.Left>
                                        <Layout.Right>
                                            <FormControl {...form.appDtlInvc.schema.othrCostVal}></FormControl>
                                        </Layout.Right>
                                    </Layout>
                                </Group.Field>

                                <Group.Control {...form.appDtlInvc.schema.othrCostTzsVal} align="right" />
                            </Group.Row>

                            <Group.Row>
                                <Group.Control {...form.appDtlInvc.schema.cstmUsdVal} align="right" />
                                <Group.Control {...form.appDtlInvc.schema.cstmTzsVal} align="right" />
                            </Group.Row>
                        </Group.Section>
                    </Layout>
                    {/* ADD ITEM DETAIL */}
                    <APP_DTL_ADD_ITM param={props.state} form={form} area={"INV"} />
                    {/* Officer ADD ITEM DETAIL */}
                    <APP_RGST_OFCR_ADD_ITM param={props.state} form={form} area={"INV"} onOfcrAddItmChange={props.onOfcrAddItmChange} onRegisterTabSave={props.onRegisterTabSave} onRegisterTabValid={props.onRegisterTabValid} />
                </Group.Body>
            </Group>
        </>
    );
};
